export default __webpack_public_path__ + "static/media/mental-and-behavioral-4.533fcd45.svg";